var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { DateTimeInput } from "react-admin";
import { useWatch } from "react-hook-form";
import { browserTimeZone } from "@sequentech/ui-core";
import { ELECTORAL_LOG_DEFAULT_ZONE_FILTER, ELECTORAL_LOG_ZONE_FILTER, } from "@/queries/ListElectoralLog";
import { useTimeZoneService } from "@/components/timezones/timeZoneService";
/** Range values stay wall times; expose the same DST resolution the query uses. */
export var LogRangeDateTimeInput = function (_a) {
    var _b;
    var source = _a.source, defaultZone = _a.defaultZone, helperText = _a.helperText, props = __rest(_a, ["source", "defaultZone", "helperText"]);
    var service = useTimeZoneService();
    var _c = useWatch({
        name: [source, ELECTORAL_LOG_ZONE_FILTER, ELECTORAL_LOG_DEFAULT_ZONE_FILTER],
    }), local = _c[0], chosen = _c[1], fallback = _c[2];
    var zone = (_b = [chosen, fallback, defaultZone].find(function (value) { return typeof value === "string" && !!value; })) !== null && _b !== void 0 ? _b : browserTimeZone();
    var note = helperText;
    if (typeof local === "string" && local) {
        try {
            var wall = local.slice(0, 16);
            var warning = service.zonedTimeNote(wall, zone, service.text);
            if (warning) {
                var resolved = service.zonedToInstant(wall, zone);
                note = (_jsxs(_Fragment, { children: [warning, " ", service.formatDateTimeZone(resolved.instant, zone, service.text)] }));
            }
        }
        catch (_d) {
            // Keep the existing input validation while a wall time is incomplete.
        }
    }
    return _jsx(DateTimeInput, __assign({}, props, { source: source, helperText: note }));
};
